import React, { useEffect, useState } from 'react';
import { FaTrash } from 'react-icons/fa';
import { imagenesCursos } from "../../utils/diccionarioImagenes";
import svgTituloMiCarrito from "../../assets/miCarrito/mi carrito.svg";

import './MiCarrito.css';

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost/backend_onelearning/api";

export default function MiCarrito({ user }) {
    const [items, setItems] = useState([]);
    const [subtotal, setSubtotal] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [appliedCoupon, setAppliedCoupon] = useState(null);
    const [couponInputs, setCouponInputs] = useState({});
    const [avatarUrl, setAvatarUrl] = useState("");

    useEffect(() => {
        if (user) {
            fetchCart();
            setAvatarUrl(user.photo_url);
        }
    }, [user]);

    const fetchCart = async () => {
        try {
            const res = await fetch(`${API_BASE}/cart/get.php?user_id=${user.id}`, { credentials: 'include' });
            const data = await res.json();
            if (data.status === 'success') {
                setItems(data.items);
                setSubtotal(parseFloat(data.total));
            }
        } catch (error) { console.error("Error cargando carrito", error); }
    };

    const removeItem = async (itemId) => {
        try {
            await fetch(`${API_BASE}/cart/remove.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ item_id: itemId }),
                credentials: 'include'
            });
            fetchCart();
        } catch (error) { console.error(error); }
    };

    // Función unificada para cambiar cualquier seguro
    const toggleInsurance = async (itemId, type) => {
        try {
            const res = await fetch(`${API_BASE}/cart/toggle_insurance.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ item_id: itemId, type: type }),
                credentials: 'include'
            });
            const data = await res.json();
            if (data.status === 'success') fetchCart();
            else alert("Error: " + data.message);
        } catch (error) { console.error(error); }
    };

    const handleInputChange = (itemId, value) => {
        setCouponInputs(prev => ({ ...prev, [itemId]: value.toUpperCase() }));
    };

    const applyItemCoupon = async (itemId) => {
        const code = couponInputs[itemId];
        if (!code) return;

        try {
            const res = await fetch(`${API_BASE}/cart/apply_coupon_item.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ item_id: itemId, code: code }),
                credentials: 'include'
            });
            const data = await res.json();

            if (data.status === 'success') {
                fetchCart();
            } else {
                alert("❌ " + data.message);
                handleInputChange(itemId, "");
            }
        } catch (e) { console.error(e); }
    };

    const finalTotal = (subtotal - discount).toFixed(2);

    const startNiubizPayment = async () => {
        if (items.length === 0) return;
        if (!user || !user.id) {
            alert("Error: No se detecta el usuario logueado.");
            return;
        }

        try {
            const res = await fetch(`${API_BASE}/payment/start_niubiz.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ coupon_code: appliedCoupon }),
                credentials: 'include'
            });
            const data = await res.json();

            if (data.status !== 'success') {
                alert("Error Backend: " + data.message);
                return;
            }

            if (window.VisanetCheckout) {
                const nombreCliente = user.first_name || 'Cliente';
                const apellidoCliente = user.last_name || 'Generico';
                let dniCliente = '00000000'; 
                const dniIngresado = prompt("Para generar el código de PagoEfectivo/Yape, por favor ingresa tu DNI:");

                if (dniIngresado && dniIngresado.length >= 8) dniCliente = dniIngresado;
                else alert("Es necesario el DNI para pagos con efectivo. Se usará un genérico para pruebas.");

                window.VisanetCheckout.configure({
                    sessiontoken: data.sessionKey,
                    channel: 'web',
                    merchantid: data.merchantId,
                    purchasenumber: data.purchaseNumber,
                    amount: Number(data.amount),
                    expirationminutes: '20',
                    timeouturl: 'about:blank',
                    merchantlogo: 'https://cdn-icons-png.flaticon.com/512/2111/2111615.png',
                    formbuttoncolor: '#117475',
                    showamount: 'true',
                    firstName: nombreCliente,
                    lastName: apellidoCliente,
                    email: user.email || 'correo@prueba.com',
                    documentType: '1',
                    documentId: dniCliente,
                    phoneNumber: '999888777',
                    recurrence: 'false',
                    action: `${API_BASE}/payment/process_niubiz.php?purchaseNumber=${data.purchaseNumber}`,
                    complete: function (params) { console.log("Completado"); }
                });

                window.VisanetCheckout.open();
            }
        } catch (error) {
            alert("Error de conexión");
        }
    };

    if (!user) return <div className="p-5 text-center" style={{marginTop:'150px'}}>Por favor, inicia sesión para ver tu carrito.</div>;

    return (
        <div className="mi-carrito-bg">
            
            <section className="miCarrito-section section-green">
                <div className="container">
                    <div className="banner-svg-container-start">
                        <div className="svg-wrapper">
                            <img src={svgTituloMiCarrito} alt="Mi Carrito" className="img-svg-titulo" />
                            <div className="zona-interactiva-avatar-mi-carrito">
                                {avatarUrl && (
                                    <div className="foto-redonda-usuario">
                                        <img src={avatarUrl} alt="Mi Avatar" />
                                    </div>
                                )}                            
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="carrito-table-container container section-white">
                
                {/* TÍTULO CENTRAL */}
                <h2 className="titulo-bolsa-compras">Bolsa de Compras</h2>

                <div className="carrito-table-header">
                    <div className="col-producto">Producto</div>
                    <div className="col-precio">Precio</div>
                    <div className="col-seguro-header"><span className="icono-escudo">🛡️</span> Seguro</div>
                    <div className="col-subtotal">Subtotal</div>
                </div>

                <div className="carrito-table-body">
                    {items.length === 0 ? (
                        <p className="empty-msg">Tu bolsa de compras está vacía.</p>
                    ) : (
                        items.map(item => {
                            const cursoImagen = imagenesCursos[item.course_id]?.desktop || "https://via.placeholder.com/150";
                            const isConSeguro = item.insurance_type !== 'none';
                            
                            // Cálculos de seguros para mostrarlos en el panel (basados en tu imagen)
                            const priceTier5 = (item.price * 0.05).toFixed(2);
                            const priceTier10 = (item.price * 0.10).toFixed(2);

                            return (
                                <div key={item.item_id} className="carrito-item-group">
                                    
                                    {/* 1. FILA GRIS PRINCIPAL */}
                                    <div className="carrito-row-gray">
                                        
                                        <div className="col-producto">
                                            <img src={cursoImagen} alt={item.title} className="tabla-img" />
                                            <div className="tabla-info">
                                                <h4 className="tabla-titulo">{item.title}</h4>
                                                <button className="btn-trash-tabla" onClick={() => removeItem(item.item_id)}>
                                                    <FaTrash />
                                                </button>
                                            </div>
                                        </div>

                                        <div className="col-precio tabla-texto-teal">
                                            S/{item.price}
                                        </div>

                                        <div className="col-seguro columna-flex-start">
                                            {/* Opción Sin Seguro */}
                                            <label className="custom-check-label">
                                                <input 
                                                    type="checkbox" 
                                                    checked={!isConSeguro} 
                                                    onChange={() => toggleInsurance(item.item_id, 'none')}
                                                />
                                                <span className="checkmark-cuadrado"></span>
                                                Sin seguro
                                            </label>

                                            {/* Opción Con Seguro */}
                                            <label className="custom-check-label">
                                                <input 
                                                    type="checkbox" 
                                                    checked={isConSeguro} 
                                                    onChange={() => {
                                                        // Si estaba "Sin seguro" y da click aquí, por defecto activamos el de 5% (10 días)
                                                        if (!isConSeguro) toggleInsurance(item.item_id, 'tier_5');
                                                    }}
                                                />
                                                <span className="checkmark-cuadrado"></span>
                                                Con seguro
                                            </label>
                                        </div>

                                        <div className={`col-subtotal ${item.applied_coupon ? 'texto-rojo' : 'texto-rojo'}`}>
                                            S/{item.final_price || item.price}
                                        </div>

                                    </div>

                                    {/* 2. CAJA DESPLEGABLE DE SEGURO (Solo se muestra si seleccionó "Con seguro") */}
                                    {isConSeguro && (
                                        <div className="seguro-dropdown-grid">
                                            <div className="seguro-dropdown-box">
                                                <div className="seguro-dropdown-opciones">
                                                    
                                                    {/* Opción 10 Días (Tier 5) */}
                                                    <label className="custom-check-label seguro-opcion">
                                                        <input 
                                                            type="checkbox" 
                                                            checked={item.insurance_type === 'tier_5'} 
                                                            onChange={() => toggleInsurance(item.item_id, 'tier_5')}
                                                        />
                                                        <span className="checkmark-cuadrado check-blanco"></span>
                                                        <div className="seguro-text-block">
                                                            10 días <br/> 5% (+${priceTier5})
                                                        </div>
                                                    </label>

                                                    {/* Opción 1 Día (Tier 10) */}
                                                    <label className="custom-check-label seguro-opcion">
                                                        <input 
                                                            type="checkbox" 
                                                            checked={item.insurance_type === 'tier_10'} 
                                                            onChange={() => toggleInsurance(item.item_id, 'tier_10')}
                                                        />
                                                        <span className="checkmark-cuadrado check-blanco"></span>
                                                        <div className="seguro-text-block">
                                                            01 día <br/> 10% (+${priceTier10})
                                                        </div>
                                                    </label>

                                                </div>
                                            </div>
                                            
                                            <p className="disclaimer-text-seguro">
                                                * Al incluir un seguro, tiene la posibilidad de retirarse del curso la cantidad de días elegidos antes de que empiece y se procederá a la devolución correspondiente al curso adquirido
                                            </p>
                                        </div>
                                    )}

                                    {/* 3. ZONA DE CUPÓN */}
                                    {!item.is_locked && (
                                        <div className="carrito-row-cupon-grid">
                                            <div className="coupon-box-gris">
                                                {!item.applied_coupon ? (
                                                    <>
                                                        <input 
                                                            type="text" 
                                                            placeholder="Escribe tu código de cupon aquí"
                                                            value={couponInputs[item.item_id] || ""}
                                                            onChange={(e) => handleInputChange(item.item_id, e.target.value)}
                                                        />
                                                        <button className="btn-aplicar-cupon" onClick={() => applyItemCoupon(item.item_id)}>Aplicar</button>
                                                    </>
                                                ) : (
                                                    <>
                                                        <input type="text" value={item.applied_coupon} readOnly className="input-applied-cupon" />
                                                        <button className="btn-aplicar-cupon">Aplicado</button>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        })
                    )}
                </div>

                {/* RESUMEN INFERIOR */}
                {items.length > 0 && (
                    <div className="carrito-resumen-inferior">
                        <div className="resumen-box">
                            <h3 className="resumen-titulo">Resumen de Compras</h3>
                            
                            <div className="resumen-totales">
                                <div className="resumen-labels">
                                    <span className="resumen-total-txt">Total del Pedido</span>
                                    <span className="resumen-impuestos">* Impuestos incluidos</span>
                                </div>
                                <div className="resumen-monto">
                                    S/{finalTotal} 
                                </div>
                            </div>

                            <div className="resumen-btn-bar">
                                <button className="btn-comprar-mi-carrito" onClick={startNiubizPayment}>Comprar</button>
                            </div>

                            <p className="resumen-terminos">
                                * Al realizar tu pedido, aceptas los <a href="#">Términos y Condiciones</a>, y que nosotros usaremos sus datos personales de acuerdo con nuestra <a href="#">Política de privacidad.</a>
                            </p>
                        </div>
                    </div>
                )}
            </section>
        </div>
    );
};